import React, { useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import "../containers/styles.scss";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { BiArchiveIn } from "react-icons/bi";
import IconButton from "../../../../../shared/components/ui/icon-button/IconButton";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import { useHistory } from "react-router-dom";
import { useFunctions } from "reactfire";
import UserNotification from "../../../../../shared/components/Notification/UserNotification";
import ConfirmationModal from "../../../../../shared/components/confirmationModal/ConfirmationModal";
import { DashboardPages } from "../../index";
import { MdRestore } from "react-icons/all";
import { zeroPad } from "../../../../../shared/utils/Commons";

interface IProps {
  index: number;
  id: string;
  title: string;
  description: string;
  imageURL: string;
  isArchived?: boolean;
  onActionStart: () => void;
  onActionFinished: () => void;
  loading: boolean;
  orderNo: number;
  thumbnail: string;
}

interface State {
  showAcceptConfirmation: boolean;
  showArchiveConfirmation: boolean;
  showRestoreConfirmation: boolean;
}

const initState: State = {
  showAcceptConfirmation: false,
  showArchiveConfirmation: false,
  showRestoreConfirmation: false,
};

const CourseComponent = (props: IProps) => {
  const appUser = useAppUser();
  const history = useHistory();
  const [state, setState] = useState(initState);

  const workshopDeleteRef = useFunctions().httpsCallable("removeWorkshop");
  const workshopArchiveRef = useFunctions().httpsCallable(
    "updateWorkshopArchiveStatus"
  );

  const deleteWorkshop = () => {
    if (!props.loading) {
      props.onActionStart();
      workshopDeleteRef(props.id)
        .then((data) => {
          UserNotification({
            isSuccess: true,
            message: "Workshop deletion success!",
          });
        })
        .catch((error) => {
          UserNotification({
            isSuccess: false,
            message: "Workshop deletion failed!",
          });
        })
        .finally(() => {
          setState({
            ...state,
            showAcceptConfirmation: false,
          });
          props.onActionFinished();
        });
    }
  };

  const restoreWorkshop = () => {
    if (!props.loading) {
      props.onActionStart();
      workshopArchiveRef(props.id)
        .then((data) => {
          UserNotification({
            isSuccess: true,
            message: "Workshop restoring success!",
          });
        })
        .catch((error) => {
          UserNotification({
            isSuccess: false,
            message: "Workshop restoring failed!",
          });
        })
        .finally(() => {
          setState({
            ...state,
            showRestoreConfirmation: false,
          });
          props.onActionFinished();
        });
    }
  };

  const archiveWorkshop = () => {
    if (!props.loading) {
      props.onActionStart();
      workshopArchiveRef(props.id)
        .then((data) => {
          UserNotification({
            isSuccess: true,
            message: "Workshop archived successfully!",
          });
        })
        .catch((error) => {
          UserNotification({
            isSuccess: false,
            message: "Workshop failed to archive!",
          });
        })
        .finally(() => {
          setState({
            ...state,
            showArchiveConfirmation: false,
          });
          props.onActionFinished();
        });
    }
  };

  const remove = (
    <IconButton
      marginRight="70px"
      color="#ff3333"
      size="md"
      onClick={() => {
        setState({ ...state, showAcceptConfirmation: true });
      }}
    >
      <RiDeleteBin6Line />
    </IconButton>
  );

  const edit = (
    <IconButton
      marginRight="70px"
      color="#fff"
      size="md"
      onClick={() => {
        history.push(`/dashboard/workshops/${props.id}/edit`);
      }}
    >
      <FiEdit style={{ color: "#000" }} />
    </IconButton>
  );

  const archive = (
    <IconButton
      marginRight="70px"
      color="#fff"
      size="md"
      onClick={() => {
        setState({ ...state, showArchiveConfirmation: true });
      }}
    >
      <BiArchiveIn style={{ color: "#000" }} />
    </IconButton>
  );

  const restoreArchived = (
    <IconButton
      marginRight="0px"
      color="#fff"
      size="md"
      onClick={() => {
        setState({ ...state, showRestoreConfirmation: true });
      }}
    >
      <MdRestore style={{ color: "#222", fontSize: "25px" }} />
    </IconButton>
  );

  const getColor = (i: number) => {
    const colorNo = i % 9;
    switch (colorNo) {
      case 0:
        return "#142459";
      case 1:
        return "#29066B";
      case 2:
        return "#820401";
      case 3:
        return "#820401";
      case 4:
        return "#176BA0";
      case 5:
        return "#7D3AC1";
      case 6:
        return "#C02323";
      case 7:
        return "#19AADE";
      case 8:
        return "#AF4BCE";
      case 9:
        return "#DE542C";
    }
  };

  const workshopControllers = () => {
    if (props.isArchived && appUser.userRole.isModerator) {
      return (
        <>
          <Col xs={12} className="p-0">
            {restoreArchived}
          </Col>
        </>
      );
    } else if (appUser.userRole.isAdmin) {
      return (
        <>
          <Col xs={4} className="p-0">
            {edit}
          </Col>
          <Col xs={4} className="p-0">
            {archive}
          </Col>
          <Col xs={4} className="p-0">
            {remove}
          </Col>
        </>
      );
    } else if (appUser.userRole.isModerator) {
      return (
        <>
          <Col xs={6}>{edit}</Col>
          <Col xs={6}>{archive}</Col>
        </>
      );
    }
  };

  return (
    <Container>
      <div>
        <Card className="cont" style={{ width: "100%" }}>
          <div
            className="image-wrapper"
            style={
              props.thumbnail
                ? {
                    backgroundImage: `url(${props.thumbnail})`,
                    backgroundSize: "100% 100%",
                  }
                : { backgroundColor: getColor(props.index) }
            }
          >
            <h6
              style={{
                color: "white",
                padding: "10px 20px",
                backgroundColor: "#000",
                display: "inline-block",
                textAlign: "center",
                borderRadius: "0 0 10px 0",
              }}
            >
              Workshop{" "}
              {props.isArchived ? "Archived" : zeroPad(props.index + 1, 2)}
            </h6>
            <Card.Img className="image" variant="top" />
            <div className="middle">
              <Container className="p-0">
                <Row>{workshopControllers()}</Row>
              </Container>
            </div>
          </div>
          <Card.Body style={{ backgroundColor: "#f1f1f1" }}>
            <Card.Title
              style={{ fontSize: "16px" }}
              className="text-left multi-line-truncate"
            >
              <strong>{props.title}</strong>
            </Card.Title>
            <div className="text-center mt-4">
              <button
                style={{
                  width: "100%",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  if (props.isArchived) {
                    history.push(
                      `${DashboardPages.ARCHIVED_WORKSHOP.replace(
                        "/:id",
                        "/".concat(props.id)
                      )}`
                    );
                  } else {
                    history.push(
                      `${DashboardPages.WORKSHOP.replace(
                        "/:id",
                        "/".concat(props.id)
                      )}`
                    );
                  }
                }}
                className="view-workshop"
              >
                View Workshop
              </button>
            </div>
          </Card.Body>
        </Card>
        {state.showAcceptConfirmation && (
          <ConfirmationModal
            children={{
              bodyText: (
                <>
                  <p>
                    This will permanently delete the workshop and all of its
                    data.
                  </p>
                  <p>The workshop cannot be recovered.</p>
                </>
              ),
              headerText: "Delete workshop",
              confirmButtonText: "Delete workshop",
              cancelButtonText: "Cancel",
              confirmButtonColor: "red",
            }}
            showConfirmInput={true}
            showConfirmInputText="DELETE"
            loading={props.loading}
            show={state.showAcceptConfirmation}
            onCancel={() =>
              !props.loading &&
              setState({ ...state, showAcceptConfirmation: false })
            }
            onConfirm={() => !props.loading && deleteWorkshop()}
          />
        )}
        {state.showArchiveConfirmation && (
          <ConfirmationModal
            children={{
              bodyText: (
                <>
                  <p>This will archive the workshop and all of its data.</p>
                  <p>You can unarchive this from archived workshop list.</p>
                </>
              ),
              headerText: "Archive workshop",
              confirmButtonText: "Archive workshop",
              cancelButtonText: "Cancel",
              confirmButtonColor: "red",
            }}
            showConfirmInput={false}
            loading={props.loading}
            show={state.showArchiveConfirmation}
            onCancel={() =>
              !props.loading &&
              setState({ ...state, showArchiveConfirmation: false })
            }
            onConfirm={() => !props.loading && archiveWorkshop()}
          />
        )}
        {state.showRestoreConfirmation && (
          <ConfirmationModal
            children={{
              bodyText: (
                <>
                  <p>This will restore the workshop and all of its data.</p>
                  <p>
                    You can archive this workshop again on the library page.
                  </p>
                </>
              ),
              headerText: "Restore workshop",
              confirmButtonText: "Restore workshop",
              cancelButtonText: "Cancel",
              confirmButtonColor: "green",
            }}
            showConfirmInput={false}
            // showConfirmInputText="DELETE"
            loading={props.loading}
            show={state.showRestoreConfirmation}
            onCancel={() =>
              !props.loading &&
              setState({ ...state, showRestoreConfirmation: false })
            }
            onConfirm={() => !props.loading && restoreWorkshop()}
          />
        )}
      </div>
    </Container>
  );
};

export default CourseComponent;
